import { render, staticRenderFns } from "./SupplierCodebookDialog.vue?vue&type=template&id=07d3bd38"
import script from "./SupplierCodebookDialog.vue?vue&type=script&lang=js"
export * from "./SupplierCodebookDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports